'use es6';

import * as client from 'DesignData/api/SiteSettings';
import { SITE_SETTINGS_FETCH } from 'DesignData/actions/ActionTypes';
/*
 * GET content-settings/v1/site-settings/by-portal-id/:portalId
 */

export function fetch(portalId) {
  const {
    request,
    receive,
    error
  } = fetch;
  return dispatch => {
    dispatch(request());
    client.fetch(portalId).then(settings => {
      dispatch(receive(settings));
    }).catch(err => {
      dispatch(error(err));
    });
  };
}

fetch.request = function request() {
  return {
    type: SITE_SETTINGS_FETCH
  };
};

fetch.receive = function receive(settings) {
  return {
    type: SITE_SETTINGS_FETCH,
    settings
  };
};

fetch.error = function error(err) {
  return {
    type: SITE_SETTINGS_FETCH,
    error: err
  };
};